import { SampleNavHeightPx, UnbHeightPx } from 'constants/navBar';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Progress, Box } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { auth } from '@landr/root-app/auth';

let loginPromise: Promise<void> | null = null;

interface PrivateRouteProps {
    isLoading: boolean;
    isAllowed: boolean;
}

const loaderContainer = css({
    position: 'relative',
    inset: '0',
    display: 'grid',
    placeItems: 'center',
    width: '100vw',
    height: '100dvh',
});

const AppLoading = () => (
    <Box
        className={loaderContainer}
        style={{ top: `-${SampleNavHeightPx + UnbHeightPx}px` }}
    >
        <Progress />
    </Box>
);

export const ProtectedRoute = ({ isLoading, isAllowed }: PrivateRouteProps) => {
    useEffect(() => {
        async function checkAuthentication() {
            if (!isLoading && !isAllowed) {
                if (!loginPromise) {
                    loginPromise = auth.login({
                        forceLoginPrompt: true,
                        mfeName: 'samples',
                    });
                }

                await loginPromise;
            }
        }

        checkAuthentication();
    }, [isLoading, isAllowed]);

    if (isLoading) {
        return <AppLoading />;
    } else if (!isAllowed) {
        return null;
    }

    return <Outlet />;
};
